/**
 * Providers Component
 *
 * Wraps the app with necessary providers:
 * - Apollo Client (GraphQL)
 * - SafeMotionProvider (SSR-safe animations)
 */

import { type ReactNode, useMemo } from 'react';
import { ApolloProvider, createApolloClient } from '@bloomcode/apollo';
import { SafeMotionProvider } from './components/ui/SafeMotion';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  const apolloClient = useMemo(
    () =>
      createApolloClient({
        graphqlEndpoint:
          import.meta.env.VITE_GATEWAY_URL || 'http://localhost:4001/gateway/graphql',
        appId: import.meta.env.VITE_APP_ID,
      }),
    []
  );

  return (
    <ApolloProvider client={apolloClient}>
      <SafeMotionProvider>{children}</SafeMotionProvider>
    </ApolloProvider>
  );
}
